module.exports = __webpack_public_path__ + "media/images/flags/16/Swaziland-a3dd9fe60898b1a3d7e685e4b6b4b4c9.png";